module.exports = __webpack_public_path__ + "img/guru.52812869.svg";